import usePostLevelValidators from 'src/redux/hooks/usePostLevelValidators';
import useAppLevelValidators from 'src/redux/hooks/useAppLevelValidators';
import ActionType from './types';

export default function useValidateUserAction(additionalParams: { [key: string]: any } = {}) {
  const { postId } = additionalParams;
  const POST_LEVEL_VALIDATORS = usePostLevelValidators({ postId });
  const BASE_VALIDATORS = useAppLevelValidators({ postId });

  const validateUserAction = (
    callbackAction?: Function,
    action?: ActionType,
  ) => {
    const anyErrorEncountered = [
      ...BASE_VALIDATORS,
      ...POST_LEVEL_VALIDATORS,
    ].some((errorEncountered) => errorEncountered(action));

    if (!anyErrorEncountered && callbackAction) {
      callbackAction();
    }
  };

  return {
    validateUserAction,
  };
}
